module.exports = __webpack_public_path__ + "img/realestate-building-products.0e06ebd5.png";